// Antd
import { Input } from 'antd'

// Interfaces
import { IBaseOtpProps } from './interfaces'

const BaseOtp = ({ maxLength, ...rest }: IBaseOtpProps) => {
  return <Input maxLength={maxLength} className="custom-input otp-input" autoFocus {...rest} />
}

export { BaseOtp }
